<span
  class="w-full flex items-center justify-center transition-opacity duration-150"
  [class.opacity-0]="showLoader()"
  ><ng-content></ng-content></span>

  @if (showLoader()) {
    <div
      class="absolute inset-0 flex items-center justify-center"
      >
      <svg
        focusable="false"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        class="block w-6 h-6 animate-ping fill-current"
        >
        <circle
          cx="50"
          cy="50"
          r="50"
          stroke-dasharray="314"
          class="t-circle"
        ></circle>
      </svg>
    </div>
  }
